import React, { useState } from 'react';
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ClippedContent, Contact as DylContact } from 'dyl-components';
import SendEmailModal from 'shared/modals/SendEmailModal';
import NotesModal from 'shared/modals/NotesModal';
import { TextMessageModal } from 'shared/modals';
import { ActivityPopup } from 'shared/forms/NewActivity';
import { PhoneUtil } from 'utils';
import appActions from 'actions/app/app';
import TextIcon from 'shared/TextIcon';
import './index.scss';

const Contact = ({ contact, name, linkToContact, jobTitle, isSimplified, hideId, isModalOutside = false, onExteriorModalOpen, hideContact, account, displayIcon, savedSettingsRoute, isCompact }) => {
    const [modal, setModal] = useState("");

    const dispatch = useDispatch();

    const { pathname } = useLocation();
    const isSettings = pathname?.split?.('/')?.[1] === "settings";
    const navigate = useNavigate();
    const isArchived = contact?.archived;
    const { emailIntegrations, officeViewCreds } = useSelector((state) => {
        return {
            officeViewCreds: state.officeView.creds,
            emailIntegrations: state.oauth_integrations.integrations
        };
    });
    const isPhoneSystemSupported =
        PhoneUtil.isPhoneSystemSupported(officeViewCreds);

    const canEmail = Boolean(contact.email?.id);
    const hasEmailIntegrations = emailIntegrations.length > 0;
    const destination = contact.phone?.find?.((phone) => phone?.main)?.phone
        || contact.phone?.[0]?.value
        || contact?.phone?.phone
        || contact?.phone?.value
    const contact_id = contact.id;
    const account_id = contact.account_id || contact.account?.id || account?.id;
    const getModal = () => {
        switch (modal) {
            case "email":
                return <SendEmailModal
                    open={modal === "email"}
                    onClose={() => { setModal("") }}
                    contact_id={contact.id}
                />;
            case "note":
                return <NotesModal
                    open={modal === "note"}
                    onClose={() => { setModal("") }}
                    contact={contact}
                />;
            case "text":
                return <TextMessageModal
                    open={modal === "text"}
                    onClose={() => { setModal("") }}
                    contact_id={contact.id}
                    contact_name={name}
                    isAccount={account}
                    disabled={!destination}
                />;
            default:
                <React.Fragment />
        }
    }

    return (
        <React.Fragment>
            <DylContact
                leftSideContent={
                    <>
                        {name && !hideContact && <Avatar name={name} maxInitials={2} round size='3em' className={isArchived ? 'Person__avatar--inactive' : ''} />}
                        <span className='Contact__Link'>
                            <ClippedContent popupContent={name}>
                                {displayIcon && <Icon className={account === "business" ? "fa-solid fa-building" : account === "household" ? "fa-solid fa-house-chimney-blank" : "user"} />}
                                {isArchived ? contact?.contact_name : linkToContact}
                            </ClippedContent>
                            {!hideId && (
                                <span className="Contact__Subtitle">
                                    {jobTitle !== undefined ? jobTitle : `ID: ${contact?.id}`}
                                </span>
                            )}
                        </span>
                    </>
                }
                isActionsVisible={!isSimplified}
                phone={destination}
                email={canEmail ? contact.email : null}
                account_id={account_id}
                contact_id={contact_id}
                isPhoneSystemSupported={isPhoneSystemSupported}
                isArchived={isArchived}
                hasEmailIntegrations={hasEmailIntegrations}
                onCallClick={() => {
                    if (isSettings) {
                        navigate(savedSettingsRoute);
                        dispatch(appActions.onSaveSettingsRoute(""));
                    }
                    PhoneUtil.C2D({
                        payload: {
                            contact_id: !account ? contact_id : null,
                            account_id: account_id,
                            destination
                        },
                        dispatch
                    });
                }}
                onTextClick={() => setModal('text')}
                onEmailClick={() => {
                    if (isModalOutside) {
                        onExteriorModalOpen('email', contact.id);
                    } else {
                        setModal("email");
                    }
                }}
                onNoteClick={() => {
                    if (isModalOutside) {
                        onExteriorModalOpen('note', contact);
                    } else {
                        setModal("note");
                    }
                }}
                ActivityPopup={ActivityPopup}
                TextIcon={TextIcon}
                callActivityProps={{
                    hideActivitySelection: true,
                    isContact: true,
                    contact: { id: account ? null : contact_id },
                    account: { id: account_id }
                }}
                emailActivityProps={{
                    readTimeline: () => { },
                    emailOnly: true,
                    contact: contact,
                    isContact: true
                }}
            />
            {!isModalOutside && getModal()}
        </React.Fragment>

    )
}

export default Contact;
